import type { ReactNode } from "react";

import {
  FileText,
  Image,
  Layers2,
  MessageCircle,
  // TrendingUp,
  // UsersRound,
} from "lucide-react";

export const BRAND_EDIT_TABS = {
  // AUDIENCE_ANALYSIS: "audience-analysis",
  BRAND_OVERVIEW: "overview",
  INSPIRATION_BOARD: "visualdirection",
  KNOWLEDGE: "knowledge",
  // OPPORTUNITY_LENS: "opportunity-lens",
  REQUESTS: "requests",
} as const;

interface TabConfigItem {
  icon: ReactNode;
  id: string;
  label: string;
}

export const TAB_CONFIG: TabConfigItem[] = [
  {
    icon: <MessageCircle size={16} />,
    id: BRAND_EDIT_TABS.BRAND_OVERVIEW,
    label: "Brand overview",
  },
  {
    icon: <Layers2 size={16} />,
    id: BRAND_EDIT_TABS.REQUESTS,
    label: "Requests",
  },
  {
    icon: <FileText size={16} />,
    id: BRAND_EDIT_TABS.KNOWLEDGE,
    label: "Brand notes",
  },
  {
    icon: <Image size={16} />,
    id: BRAND_EDIT_TABS.INSPIRATION_BOARD,
    label: "Visual direction",
  },
  // {
  //   icon: <TrendingUp size={16} />,
  //   id: BRAND_EDIT_TABS.OPPORTUNITY_LENS,
  //   label: "Opportunity lens",
  // },
  // {
  //   icon: <UsersRound size={16} />,
  //   id: BRAND_EDIT_TABS.AUDIENCE_ANALYSIS,
  //   label: "Audience analysis",
  // },
];
